"use client";

import { Suspense } from "react";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ThemeProviderProps } from "next-themes";
import { ToastProvider } from "@/components/ui/Toast";
import { Navbar } from "@/components/navbar";
import { I18nProvider } from "@/i18n/context";
import { Skeleton } from "@/components/ui/Skeleton";

export function Providers({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider 
      attribute="class" 
      defaultTheme="system" 
      enableSystem
      {...props}
    >
      {/* 
        Wrap the I18nProvider and all its children in Suspense.
        This prevents client-side dynamic checks (like reading localStorage in I18nProvider)
        from blocking the static prerendering of routes like /admin or /articles.
      */}
      <Suspense fallback={null}>
        <I18nProvider>
          <ToastProvider>
            <Suspense fallback={<Skeleton className="h-16 w-full rounded-none" />}>
              <Navbar />
            </Suspense>
            {children}
          </ToastProvider>
        </I18nProvider>
      </Suspense>
    </NextThemesProvider>
  );
}